export { SideBarModule } from "./sideBarModule";
export { ToolPanelColDefService } from "./sideBar/common/toolPanelColDefService";



//////////////////
// WEBPACK FOOTER
// ./node_modules/@ag-grid-enterprise/side-bar/dist/es6/main.js
// module id = 630
// module chunks = 0